export type PanelPoint = { x: number; y: number };
export type PanelSize = { width: number; height: number };

const VIEWPORT_MARGIN = 8;

export function clampPanelPosition(
  next: PanelPoint,
  panel: PanelSize,
  viewport: PanelSize,
  margin = VIEWPORT_MARGIN,
): PanelPoint {
  const maxX = Math.max(margin, viewport.width - panel.width - margin);
  const maxY = Math.max(margin, viewport.height - panel.height - margin);
  return {
    x: Math.min(maxX, Math.max(margin, next.x)),
    y: Math.min(maxY, Math.max(margin, next.y)),
  };
}

export function movePanelByDelta(
  origin: PanelPoint,
  delta: PanelPoint,
  panel: PanelSize,
  viewport: PanelSize,
): PanelPoint {
  return clampPanelPosition(
    { x: origin.x + delta.x, y: origin.y + delta.y },
    panel,
    viewport,
  );
}

export function isPanelDragHandleTarget(target: EventTarget | null, handle: Element | null): boolean {
  if (!(target instanceof Element) || !handle) return false;
  if (target.closest('button, a, input, textarea, select')) return false;
  return handle.contains(target);
}
